import { CopyOutlined } from "@ant-design/icons";
import { App, Button, Flex, Modal, ModalProps, Spin, Typography } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BarcodeItem, BarcodeWrap } from "./style";

const { Paragraph } = Typography;

interface ICodeShowShowProps extends ModalProps {
  loading: boolean;
  barCodes: Array<string>;
}

const CodeShow: FC<ICodeShowShowProps> = ({
  loading,
  barCodes,
  ...modalProps
}) => {
  const { notification } = App.useApp();
  const { t } = useTranslation();

  const copyAllBarCodes = async () => {
    if (barCodes && barCodes.length > 0) {
      try {
        const allBarCodes = barCodes.join("\n");
        await navigator.clipboard.writeText(allBarCodes);
        notification.success({ placement: 'top', message: t("order.copySuccess") });
      } catch (error) {
        const errorMes =
          error instanceof Error ? error.message : t("order.copyFail");
        notification.error({ placement: 'top', message: errorMes });
      }
    }
  };

  return (
    <Modal
      title={t("order.codeListWithCount", { count: barCodes.length })}
      footer={null}
      {...modalProps}
    >
      {loading && (
        <Spin style={{ display: "flex", justifyContent: "center" }} />
      )}
      {barCodes && barCodes.length > 0 && (
        <Flex vertical justify="end" gap={10}>
          <div style={{ textAlign: 'right' }}>
            <Button
              type="primary"
              icon={<CopyOutlined />}
              onClick={() => copyAllBarCodes()}
            >
              {t("order.copyAll")}
            </Button>
          </div>
          <BarcodeWrap>
            {barCodes.map((item: string, index: number) => (
              <BarcodeItem justify="start" key={index}>
                <span>{index + 1}：</span>
                <Paragraph copyable style={{ marginBottom: "0" }}>
                  {item}
                </Paragraph>
              </BarcodeItem>
            ))}
          </BarcodeWrap>
        </Flex>
      )}
    </Modal>
  );
};

export default CodeShow;
